export const BRANDS = [
  {
    name: "FlexPei",
    domain: "flexpei.com",
    url: "https://flexpei.com",
    category: "Fintech",
    metric: "150K+",
    metricLabel: "Transacciones de pago",
    desc: "Plataforma de servicios financieros: banca digital, exchange de criptomonedas y pagos internacionales.",
    image:
      "/img/photo-1605792657660-596af9009e82.webp",
    status: "live",
    span: "lg:col-span-2",
  },
  {
    name: "CallMarket",
    domain: "callmarket.cc",
    url: "https://callmarket.cc",
    category: "Contact Center",
    metric: "1M+",
    metricLabel: "Llamadas procesadas",
    desc: "Software de contact center: campañas automatizadas, IVR, robocalls y encuestas telefónicas.",
    image:
      "/img/photo-1561233835-f937539b95b9.webp",
    status: "live",
    span: "",
  },
  {
    name: "Mastiket",
    domain: "mastiket.com",
    url: "https://mastiket.com",
    category: "Ticketing",
    metric: "120K+",
    metricLabel: "Boletos vendidos",
    desc: "Plataforma de venta de boletos en línea para conciertos, festivales y eventos en vivo.",
    image:
      "/img/photo-1533174072545-7a4b6ad7a6c3.webp",
    status: "live",
    span: "",
  },
  {
    name: "FluxiPay",
    domain: "fluxipay.com",
    url: "https://fluxipay.com",
    category: "Payments",
    metric: "80K+",
    metricLabel: "Transacciones crypto",
    desc: "Pasarela de pagos con criptomonedas para comercios y plataformas digitales.",
    image:
      "/img/photo-1518546305927-5a555bb7020d.webp",
    status: "live",
    span: "",
  },
  {
    name: "resbok",
    domain: "resbok.com",
    url: "https://www.resbok.com",
    category: "Hospitality",
    metric: "25K+",
    metricLabel: "Reservaciones completadas",
    desc: "Sistema de reservaciones para restaurantes con mapa interactivo de mesas y disponibilidad en tiempo real.",
    image:
      "/img/pexels-photo-5865162.webp",
    status: "live",
    span: "",
  },
  {
    name: "MisTrámites",
    domain: "mistramites.mx",
    url: "https://mistramites.mx",
    category: "GovTech",
    metric: "10K+",
    metricLabel: "Trámites procesados",
    desc: "Plataforma integral para trámites mexicanos con seguimiento 24/7 y más de 60 gestiones en 17 categorías.",
    image:
      "/img/pexels-photo-8730998.webp",
    status: "live",
    span: "lg:col-span-2",
  },
  {
    name: "ActivMedios",
    domain: "activmedios.com",
    url: "https://activmedios.com",
    category: "AdTech",
    metric: "En desarrollo",
    metricLabel: "Lanzamiento próximo",
    desc: "Plataforma de marketing de desempeño, campañas publicitarias y operaciones de telemarketing.",
    image:
      "/img/pexels-photo-6203470.webp",
    status: "dev",
    span: "",
  },
  {
    name: "Masaldo",
    domain: "masaldo.com.mx",
    url: "https://masaldo.com.mx",
    category: "Cashless",
    metric: "En desarrollo",
    metricLabel: "Lanzamiento próximo",
    desc: "Sistema de pagos cashless con pulseras RFID para eventos masivos y establecimientos.",
    image:
      "/img/pexels-photo-30903758.webp",
    status: "dev",
    span: "",
  },
];

export const REASONS = [
  "Cotizar proyecto",
  "Consultoría técnica",
  "Alianzas estratégicas",
  "Soporte técnico",
  "Únete al equipo",
  "Información general",
];
